import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CartDrawer } from "@/components/site/CartDrawer";
import { useConsent } from "@/context/ConsentContext";
import { usePageTracking } from "@/lib/analytics";

export default function Layout() {
  const { pathname } = useLocation();
  const { consent } = useConsent();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  usePageTracking(pathname, consent);

  return (
    <div className="flex min-h-screen flex-col bg-[#FDFBF7] text-[#1A1A1A]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
